export const selectedVendorDetails = (
  vendors: any[],
  selectedVendorId: number,
) => {
  const selectedVendor = vendors.find(
    (vendor) => vendor?.vendorId === selectedVendorId,
  );

  if (selectedVendor) {
    return `${selectedVendor?.vendorName} - ${selectedVendor?.proposedPrice}`;
  } else {
    return `Name - Price`;
  }
};
